import React from "react";
import { getRequest } from "sharedUtils/httpUtils";
import MUIDataTable from "mui-datatables";
import { convertToNumericMonthAndDayAndYearAndTime } from "sharedUtils/timeUtils";
import { ThemeProvider, createTheme } from "@material-ui/core/styles";
import { CheckIconBlack } from "../../icons";
import PenIcon from "components/icons/PenIcon";

const { DateTime } = require("luxon");

class ShareASaleCommissionData extends React.Component {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();

        this.state = {
            commissions: [],
            commissionsLoading: false,
            affiliateCommissionId: this.props.affiliateCommissionId,
            affiliateCommissionIdError: false,
            CommissionsTable: {
                title: "Affiliate commissions",
                options: {
                    selectableRows: "multiple",
                    rowsPerPage: 100,
                    sortOrder: {
                        name: 'commissionName',
                        direction: 'asc'
                    },
                },
                getTheme: () => createTheme({
                    typography: {
                        fontFamily: "'Urbanist', 'sf_pro_displayregular', sans-serif",
                    },
                    overrides: {
                        MUIDataTableBodyRow: {
                            root: {
                                '&:nth-child(odd)': {
                                    backgroundColor: '#F9F9F9'
                                },
                                cursor: 'pointer'
                            }
                        },
                        MUIDataTableBody: {
                            emptyTitle: {
                                textAlign: 'left',
                                paddingLeft: '385px',
                                paddingTop: '12px',
                                verticalAlign: 'top',
                                fontFamily: "'Urbanist', sans-serif",
                                fontSize: '16px',
                            }
                        }
                    }
                })
            },
        };
    }

    componentDidMount = () => {
        window.scrollTo({ left: 0, top: 0, behavior: 'auto' });

        if (!!(this.props.affiliateCommissionId)) {
            this.getCommissions();
        }
    };

    componentDidUpdate = (prevProps, prevState) => {
        if (!!(this.props.affiliateCommissionId) && prevProps.affiliateCommissionId !== this.props.affiliateCommissionId) {
            this.getCommissions();
        }
    }

    getCommissions = async () => {
        if (!(this.props.affiliateCommissionId)) {
            this.setState({ affiliateCommissionIdError: true });
        }
        console.log("in")

        let url = `/api/Merchant/GetShareASaleCommissionRawDataById?id=` + this.props.affiliateCommissionId;

        this.setState({ commissionsLoading: true, affiliateCommissionIdError: false });

        try {
            const commissions = await getRequest(url);

            this.setState({
                commissions,
                commissionsLoading: false,
            });
        } catch (error) {
            console.error("Error fetching commissions:", error);
            this.setState({ commissions: [], commissionsLoading: false });
        }
    };

    onTabChange = (tab) => {
        this.setState({ tab });
    }

    render() {
        const columns = [
            {
                name: "shareASaleTransactionId",
                label: "ShareASale Transaction ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "shareASaleCommissionCreatedDate",
                label: "Commission Created Date",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{!!value ? convertToNumericMonthAndDayAndYearAndTime(new Date(value), false) : "-"}</span>;
                    }
                }
            },
            {
                name: "id",
                label: "Commission History ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "userId",
                label: "User ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "rockPorchUserId",
                label: "RockPorch User ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "merchantId",
                label: "Merchant ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "transactionDate",
                label: "Transaction Date",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{!!value ? convertToNumericMonthAndDayAndYearAndTime(new Date(value), false) : "-"}</span>;
                    }
                }
            },
            {
                name: "transactionAmount",
                label: "Transaction Amount",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{value != null ? `$${value.toFixed(2)}` : "-"}</span>;
                    }
                }
            },
            {
                name: "commission",
                label: "Commission",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{value != null ? `$${value.toFixed(2)}` : "-"}</span>;
                    }
                }
            },
            {
                name: "comment",
                label: "Comment",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "voided",
                label: "Voided",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "pendingDate",
                label: "Pending Date",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{!!value ? convertToNumericMonthAndDayAndYearAndTime(new Date(value), false) : "-"}</span>;
                    }
                }
            },
            {
                name: "locked",
                label: "Locked",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "affComment",
                label: "Affiliate Comment",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "bannerPage",
                label: "Banner Page",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "reversalDate",
                label: "Reversal Date",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{!!value ? convertToNumericMonthAndDayAndYearAndTime(new Date(value), false) : "-"}</span>;
                    }
                }
            },
            {
                name: "clickDate",
                label: "Click Date",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{!!value ? convertToNumericMonthAndDayAndYearAndTime(new Date(value), false) : "-"}</span>;
                    }
                }
            },
            {
                name: "clickTime",
                label: "Click Time",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "bannerId",
                label: "Banner ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "skuList",
                label: "SKU List",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "quantityList",
                label: "Quantity List",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "lockDate",
                label: "Lock Date",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{!!value ? convertToNumericMonthAndDayAndYearAndTime(new Date(value), false) : "-"}</span>;
                    }
                }
            },
            {
                name: "paidDate",
                label: "Paid Date",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{!!value ? convertToNumericMonthAndDayAndYearAndTime(new Date(value), false) : "-"}</span>;
                    }
                }
            },
            {
                name: "merchantOrganization",
                label: "Merchant Organization",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "merchantWebsite",
                label: "Merchant Website",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "transactionType",
                label: "Transaction Type",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "merchantDefinedType",
                label: "Merchant Defined Type",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "storeId",
                label: "Store ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "referenceTransaction",
                label: "Reference Transaction",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "createdBy",
                label: "Created By",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "createdDate",
                label: "Created Date",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{!!value ? convertToNumericMonthAndDayAndYearAndTime(new Date(value), false) : "-"}</span>;
                    }
                }
            },
            {
                name: "modifiedBy",
                label: "Modified By",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "modifiedDate",
                label: "Modified Date",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{!!value ? convertToNumericMonthAndDayAndYearAndTime(new Date(value), false) : "-"}</span>;
                    }
                }
            }
        ];


        return (
            <div>
                <ThemeProvider theme={this.state.CommissionsTable.getTheme()}>
                    <MUIDataTable
                        title={
                            <div style={{ fontFamily: "'Urbanist', sans-serif" }}>
                                <p style={{ fontSize: '22px', marginTop: "20px" }}>{this.props.affiliateProgramManager?.name + " commissions by ID" ?? "No affiliate selected"}</p>
                                <p style={{ fontSize: '16px', marginTop: "10px", color: "red", display: this.state.affiliateCommissionIdError ? "" : "none" }}>Enter an affiliate commission ID</p>
                            </div>
                        }
                        data={this.state.commissions}
                        columns={columns}
                        options={{
                            ...this.state.CommissionsTable.options,
                            textLabels: {
                                body: { noMatch: this.state.commissionsLoading ? "LOADING..." : "No data available" },
                            },
                            selectableRows: "none",
                        }}
                        ref={this.tableRef}
                    />
                </ThemeProvider>
            </div>
        );
    }
}

export default ShareASaleCommissionData;
